import {createMachine, actions, send, assign} from "xstate";
import validateUrlAsync from "../../helpers/validateUrlAsync";

const createShareIntentMachine = (options) => {
    return createMachine({
        id: 'share-intent-machine',
        initial: 'idle',
        context: {
            validationErrorMessage: null
        },
        states: {
            idle: {
                on: {
                    SUBMIT: 'validating',
                    CANCEL: 'cancel'
                },
                initial: 'idle',
                states: {
                    idle: {},
                    invalid: {}
                }
            },
            validating: {
                invoke: {
                    id: 'validating',
                    src: (_, {url}) => validateUrlAsync(url),
                    onDone: {
                        target: 'submitting',
                        actions: assign({
                            validationErrorMessage: null
                        })
                    },
                    onError: {
                        target: 'idle.invalid',
                        actions: assign({
                            validationErrorMessage: (ctx, event) => event.data.message
                        })
                    }
                }
            },
            submitting: {
                invoke: {
                    id: 'submit',
                    src: (ctx, {data: url}) => {
                        return axios.post('/me/entries', {
                            url
                        }).then(response => response.data);
                    },
                    onDone: {
                        target: 'submitted',
                        actions: send('SUCCESS'),
                    },
                    onError: {
                        target: 'idle'
                    }
                }
            },
            cancel: {
                invoke: {
                    src: 'navigateAway',
                },
                type: 'final'
            },
            submitted: {
                invoke: {
                    src: 'navigateAway',
                },
                type: 'final'
            }
        }
    }, options);
};

export {createShareIntentMachine};
